import app from 'flarum/forum/app';

export default class LayaSSO {

  islogin = false;
  login() {
    if (this.islogin) {
      return;
    }
    this.islogin = true

    // 检查URL中是否存在token参数
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const token = urlParams.get('token');

    if (token) {
      app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/laya/sso',
        body: {
          token
        }
      }).then(() => {
        urlParams.delete('token');
        window.location.href = url.toString();
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
